import React from 'react'

import { useLightMode } from '@/hooks/useLightMode'

import { FileViewer } from '@hivewatch/dark'

import { IncidentNotesMediaType } from '../../shared/types/feedTypes'
import { IncidentNoteVideoPlayer } from '../components/IncidentNoteVideoPlayer'

interface MediaPreviewerModalIProps {
  onClose: () => void
  isOpen: boolean
  file: IncidentNotesMediaType
}

/**
 * Thin adapter from the incident-drawer's note-media shape onto the dark
 * package FileViewer (ENG-32107) — the signature is unchanged so MediaGrid and
 * IncidentImages call sites don't move. Video goes through `mediaOverride` so
 * react-player stays a web-app dependency. Callers snapshot `file` in state
 * before opening (the incident query re-signs URLs every 3s); the viewer never
 * sees a live URL.
 */
export const MediaPreviewerModal = ({
  file,
  onClose,
  isOpen,
}: MediaPreviewerModalIProps) => {
  const colorScheme = useLightMode()
  // mimeType is optional on some sources (media-player attachments sniff it);
  // no mimeType simply means FileViewer's fallback card, not a crash.
  const isVideo = Boolean(file.mimeType?.includes('video'))

  return (
    <FileViewer
      colorScheme={colorScheme}
      file={{ src: file.url, name: file.name, mimeType: file.mimeType }}
      isOpen={isOpen}
      mediaOverride={
        isVideo ? <IncidentNoteVideoPlayer videoUrl={file.url} /> : undefined
      }
      onClose={onClose}
      zIndex={1500}
    />
  )
}
